export default {
  tooltips: {
    expand: "展开",
    collapse: "收起",
    delete: "删除",
    duplicateAddressMark: "地址重复标识",
  },
  remark: "备注",
};
